import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'
const getTranslateMasterFilters = function () {
  return {
  // created_at_from: { label: 'Creado desde', value: '', type: 'date' },
  // created_at_to: { label: 'Creado hasta', value: '', type: 'date' },
    expires_from: { label: i18n.t('certificates.expires_date_from'), value: '', type: 'date' },
    expires_to: { label: i18n.t('certificates.expires_date_to'), value: '', type: 'date' },
    name: { label: i18n.t('app.name'), value: '' },
    serial: { label: i18n.t('certificates.serial'), value: '' },
    empresa: { label: i18n.t('clients.entity_name'), value: '' },
    tipoCert: { label: i18n.t('app.type'), value: '' }
  }
}
const getColumns = function getColumns () {
  return [
    {
      field: 'Distribuidor',
      title: i18n.t('distributors.entity_name'),
      columnMenu: 'myTemplate',
      hidden: true,
      locked: false,
      width: '180px',
      only: {
        roles: [3],
      }, 
    },
    {
      field: 'Cliente',
      width: '450px',
      title: i18n.t('clients.entity_name'),
      columnMenu: 'myTemplate',
      locked: false,
      hidden: true,
      only: {
        roles: [7, 8, 3],
      }, 
    },
    { field: 'CommonName', width: '450px', title: i18n.t('app.name'), columnMenu: 'myTemplate', locked: false },
    { field: 'SerialNumber', width: '450px', title: i18n.t('app.serial_number'), columnMenu: 'myTemplate', locked: false },
    { field: 'FechaCaducidad', width: '250px', title: i18n.t('certificates.expires_at'), type: 'date', filter: 'date', format: 'numeric_datetime', cell: 'fechaTemplate', columnMenu: 'myTemplate', locked: false, extraparams: { separators: { date: '-', datetime: ' ' } } },
    { field: 'TipoCertificadoNombre', width: '285px', title: i18n.t('app.type'), format: 'TIPOS_CERT', cell: 'enumTemplate', columnMenu: 'myTemplate', locked: false },
    { field: 'TipoCertificado', width: '150px', title: i18n.t('certificates.cod_type'), columnMenu: 'myTemplate', locked: false, hidden: true },
    {
      field: 'idCliente',
      width: '100px',
      title: i18n.t('clients.id_client'),
      columnMenu: 'myTemplate',
      locked: false,
      hidden: true,
      only: {
        roles: [7, 8, 3],
      }, 
    }
  ] 
}
const mystore = parent({ selectable: true, navigate: true, namespaced: true, getTranslateColumns: getColumns, getTranslateMasterFilters })

export default mystore
